import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { SherpaCustomersView } from './customers/customers';

export const SherpaView = angular
  .module('acme.view.application.sherpa', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.sherpa.controllers',
    SherpaCustomersView,
    'acme.view.application.sherpa.activities',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const sherpa = {
      name: 'application.sherpa',
      url: '/sherpa',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'SherpaController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/sherpa/sherpa.tpl.html',
        },
      },
      data: {
        pageTitle: 'CSR',
      },
    };

    $stateProvider.state(sherpa);
  }).name;
